// extracted by mini-css-extract-plugin
var _1 = "SearchSection-moduleSearchSection__BSBGv";
var _2 = "SearchSection-moduleheader__uNHu1 SearchSectionHeader-moduleSearchSectionHeader__c9B21";
export { _1 as "SearchSection", _2 as "header" }
